/**
 * Guard for frontend call sites whose endpoint the Flask backend has never
 * exposed.
 *
 * SOF-26 replaced these literals with an explicit failure that the consuming
 * Redux slices already surface to the UI, so a missing backend contract is
 * visible instead of arriving as a bare HTTP 404. Each call site records the
 * endpoint it used to call and the backend route that serves the feature
 * instead, when one exists.
 */
const unroutedEndpoint = (endpoint, replacement, detail = {}) => {
  const suffix = replacement ? ` Use ${replacement} instead.` : "";
  const error = new Error(`The backend does not serve ${endpoint}.${suffix}`);
  error.code = "unrouted_endpoint";
  error.endpoint = endpoint;
  error.replacement = replacement || "";
  error.detail = detail;
  return Promise.reject(error);
};

export default unroutedEndpoint;
